import MiniCartCouponView from './mini-cart-coupons-view'

export default MiniCartCouponView
